module.exports = new __parcel__URL__("zak-120bpm.f1ef8ffb.mp3").toString();